import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';

import { setRemainingTime } from '../../reduxStore/actions/action';


function GamePlayModals({ isOpenModal, setIsOpenModal, title, btnText,
  subText, setTriggerFunction, triggerValue, isNextActive, setShowDiceBtn, runTimer, setRemainingTime, gameIntroSteps, fetchGameState, countSelected, correctValueBuddies, utilAssets }) {
  useEffect(() => { setIsOpenModal(true) }, [])
  const handleNext = () => {
    if (isNextActive) {

      setTriggerFunction(1)
      setShowDiceBtn(false);
      setIsOpenModal(false);

    } else if (gameIntroSteps == 4) {


      setShowDiceBtn(true);
      setIsOpenModal(false);

      fetchGameState(() => {
        setRemainingTime(1);
        runTimer();
      }, () => { })


    } else {
      setIsOpenModal(false);
      setShowDiceBtn(false);

    }
  }

  console.log("correeeee", countSelected, correctValueBuddies)



  return (
    <Modal
      visible={isOpenModal}
      onCancel={() => setIsOpenModal(false)}
      footer={null}
      maskClosable={false}
      closeIcon={false}
      className='token-model'
      width={1000}
      style={{ overflow: 'hidden !important' }}
      centered={true}
    >
      <div className="r-c-c" style={{ width: "100%", height: "100%", textAlign: "center" }}>
        <div className="r-c-c letsPlayFrame" style={{}} ><img style={{ width: "100%" }} src={utilAssets?.modalBg} alt="lets play" /></div>
        <div className='r-c-c-c' style={{}} >
          <div className="r-c-c-c letsPlay" style={{ left: "30%", width: "41%", color: "#44301E", minHeight: "50%" }}>
            {title}
            <div style={{ fontSize: "20px", fontWeight: "bold" }} >{subText ? subText : null}</div>
            <div className='r-c-c play-btn m-t-20' style={{ position: "relative", minWidth: "100%" }} >
              <Button onClick={handleNext}>{btnText}</Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}


export default GamePlayModals;
